/** Tenant slug resolution — `cloud.sakhtar.net/t/{slug}/...` (SOT §9). */

export function tenantSlugFromPathname(pathname: string): string | null {
  const match = /^\/t\/([^/]+)/.exec(pathname);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function tenantBasePath(slug: string): string {
  return `/t/${encodeURIComponent(slug)}`;
}
